<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <loading-component v-if="isNotAdminRoute && loading" />
      <update-notification />
      <missions-welcome-popup />
      <router-view :hidden="isNotAdminRoute && loading" />
    </div>
  </a-config-provider>
</template>
<script>
import LoadingComponent from "@/components/LoadingComponent.vue";
import UpdateNotification from "@/components/core/UpdateNotification.vue";
import MissionsWelcomePopup from "@/components/MissionsWelcomePopup.vue";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import esES from "ant-design-vue/lib/locale-provider/es_ES";
import { version, name } from "../package.json";
export default {
  // Screen width
  components: { LoadingComponent, UpdateNotification, MissionsWelcomePopup },
  data() {
    return {
      screenWidth: window.innerWidth,
      locale: esES,
    };
  },
  created() {
    this.checkVersion();
    this.updateLayout({
      screenWidth: window.innerWidth,
      selectedKeys: [this.$route.name],
    });
    this.screenWidth = window.innerWidth;
    window.addEventListener("resize", () => {
      this.screenWidth = window.innerWidth;
    });
  },
  computed: {
    ...mapState(["loading"]),
    ...mapState("layout", ["darkMode"]),
    isNotAdminRoute() {
      return !(this.$route?.fullPath || "").includes("admin");
    },
    loggedUser() {
      return this.$store.getters["clientAuth/getLoggedUser"];
    },
  },
  methods: {
    ...mapActions("layout", ["updateLayout"]),
    async checkVersion() {
      const storedVersion = localStorage.getItem(name);
      const pkgVersion = version;

      // 1. Verificar contra el package.json (bundle actual)
      if (storedVersion !== pkgVersion) {
        if (window.caches) {
          try {
            const names = await caches.keys();
            await Promise.all(names.map((name) => caches.delete(name)));
            console.log(
              "[App] Caché de Service Worker limpiado por cambio de versión en bundle"
            );
          } catch (e) {
            console.error("Error limpiando caché:", e);
          }
        }
        localStorage.setItem(name, pkgVersion);
      }

      // 2. Verificar contra el servidor (version.json) para detectar si hay algo más nuevo afuera
      try {
        const response = await fetch(`/version.json?t=${Date.now()}`, {
          cache: "no-store",
          headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
        });
        if (response.ok) {
          const data = await response.json();
          const lastTs = localStorage.getItem("app_version_timestamp");

          if (lastTs && parseInt(data.timestamp) > parseInt(lastTs)) {
            // Si no estamos en una ruta crítica, recargar de inmediato
            const criticalPaths = ["/buy", "/transaction/request"];
            const isCritical = criticalPaths.some((p) =>
              window.location.pathname.includes(p)
            );

            if (!isCritical) {
              console.log(
                "[App] Nueva versión detectada en el servidor. Limpiando y recargando..."
              );

              // Limpiar caches
              if (window.caches) {
                const names = await caches.keys();
                await Promise.all(names.map((name) => caches.delete(name)));
              }

              localStorage.setItem("app_version_timestamp", data.timestamp);
              window.location.reload();
            } else {
              console.log(
                "[App] Nueva versión detectada, pero el usuario está en ruta crítica. Postergar."
              );
            }
          } else if (!lastTs) {
            localStorage.setItem("app_version_timestamp", data.timestamp);
          }
        }
      } catch (err) {
        console.error("Error verificando versión externa:", err);
      }
    },
  },
  destroyed() {
    window.removeEventListener("resize", () => {
      this.screenWidth = window.innerWidth;
    });
  },
  watch: {
    screenWidth(newValue) {
      this.updateLayout({ screenWidth: newValue });
    },
    $route(to, from) {
      if (!_.isEqual(to, from)) {
        this.updateLayout({
          selectedKeys: [to.name],
        });
      }
    },
    darkMode: {
      handler(val, old) {
        if (val === old) return;
        if (val) {
          document.body.classList.remove("light");
        } else {
          document.body.classList.add("light");
        }
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Exo+2:wght@400;500;700&family=Roboto:wght@400;500&display=swap");
@import "assets/scss/styles.scss";

.ant-layout-content {
  background: #fff;
}
</style>
